import * as React from "react";
import type { SVGProps } from "react";
const SvgMapMarker = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 42 49" {...props}>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M42 21C42 9.402 32.598 0 21 0S0 9.402 0 21c0 2.871.576 5.608 1.62 8.1C5.944 40.912 21.11 49 21.11 49s18.629-9.935 20.483-23.864A21.1 21.1 0 0 0 42 21Z"
      clipRule="evenodd"
    />
    <path
      fill="#F75751"
      fillRule="evenodd"
      d="m38.65 24.785-.018.096-.013.098c-.776 5.897-5.176 11.3-9.924 15.449A57.632 57.632 0 0 1 21.11 46a58.635 58.635 0 0 1-6.238-4.436c-4.192-3.422-8.554-8.026-10.436-13.22l-.023-.065-.026-.063A18.305 18.305 0 0 1 3 21.198C3 11.148 11.059 3 21 3s18 8.147 18 18.198c0 1.23-.12 2.43-.35 3.587Z"
      clipRule="evenodd"
    />
    <path fill="#fff" d="M29 21a8 8 0 1 0-16 0 8 8 0 0 0 16 0Z" />
  </svg>
);
export default SvgMapMarker;
